import { env } from '@/env/client'
import { getAbsoluteUrl } from '@/utils/url'

const baseUrl = env.NEXT_PUBLIC_BASE_URL

const supportEmail = 'support@backlinkgpt.com'

export const siteConfig = {
  name: 'BacklinkGPT',
  organization: 'BacklinkGPT',
  url: baseUrl,
  organizationUrl: 'https://backlinkgpt.com',
  appUrl: getAbsoluteUrl('/app'),
  logo: getAbsoluteUrl('/og/logo.png'),
  // TODO
  ogImage: getAbsoluteUrl('/og/banner.jpg'),
}

export type SiteConfig = typeof siteConfig
